import { render, staticRenderFns } from "./projectmodal.component.html?vue&type=template&id=1ba027af&scoped=true&"
import script from "./projectmodal.component.ts?vue&type=script&lang=ts&"
export * from "./projectmodal.component.ts?vue&type=script&lang=ts&"
import style0 from "./projectmodal.component.scss?vue&type=style&index=0&id=1ba027af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba027af",
  null
  
)

export default component.exports